import NavHash from '@/components/parts/nav/Hash.vue';
import MarkupPopup from '@/components/parts/markup/Popup.vue';
import FormForget from './forget';
import FormSignin from './signin';
import FormSignup from './signup';
import mixinHash from './mixin';

import isLocation from '@/mixins/isLocation';
import AuthServices from './authServices/AuthServices';

import { HASH_FORGET, HASH_SIGNIN, HASH_SIGNUP, HASH_AUTH_SERVICES } from './const.js';

export default {
  name: 'ViewDefaultPopupForms',

  components: {
    FormForget,
    FormSignin,
    FormSignup,
    MarkupPopup,
    NavHash,
    AuthServices,
  },

  mixins: [mixinHash, isLocation],

  data: () => ({ isMounted: false }),

  computed: {
    isVisible() {
      const { isMounted, routeHash, noRegistrationOrOrder } = this;
      return (
        isMounted &&
        [
          HASH_FORGET,
          HASH_SIGNIN,
          HASH_AUTH_SERVICES,
          noRegistrationOrOrder ? null : HASH_SIGNUP,
        ].includes(routeHash)
      );
    },

    popupNav() {
      const { $route, routeHash, noRegistrationOrOrder } = this;
      const { name, params, query } = $route;

      const authRulesList = this.$store.state.apiModules.find(
        (el) => el.alias === 'clientAuth'
      );
      const bookingUrls = this.$store.state.regionProfile.bookingUrls
        ? this.$store.state.regionProfile.bookingUrls
        : null;
      const navList = [
        {
          caption: 'Вход для пользователя',
          hash: HASH_SIGNIN,
          isActive: authRulesList ? authRulesList.is_allow_base_login : true,
          extUrl: null,
        },
        {
          caption: 'Регистрация пользователя',
          hash: HASH_SIGNUP,
          isActive: authRulesList ? authRulesList.is_allow_base_register : true,
          extUrl: null,
        },
        {
          caption: 'Не помню пароль',
          hash: HASH_FORGET,
          isActive: true,
          extUrl: null,
        },
        {
          caption: 'Регистрация организации',
          isActive: bookingUrls && bookingUrls.signUp,
          hash: null,
          extUrl: bookingUrls.signUp,
        },
        {
          caption: 'Вход для организации',
          isActive: bookingUrls && bookingUrls.signIn,
          hash: null,
          extUrl: bookingUrls.signIn,
        },
      ];
      return navList
        .filter((el) => el.isActive)
        .map(({ caption, hash, extUrl }) => ({
          caption,
          selected: hash === routeHash,
          hashName: hash,
          to: { name, params, query, hash: hash ? ['#', hash].join(''): null, extUrl },
        }));
    },

    isSignupVisible() {
      return this.routeHash === HASH_SIGNUP;
    },

    isSigninVisible() {
      return this.routeHash === HASH_SIGNIN;
    },

    isForgetVisible() {
      return this.routeHash === HASH_FORGET;
    },
    isAuthServices() {
      return this.routeHash === HASH_AUTH_SERVICES;
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.isMounted = true;
    });
  },
  props: {
    fromScreen: {
      type: Boolean,
      default: false,
    },
  },

  metaInfo() {
    return this.isVisible
      ? {
          bodyAttrs: {
            'data-modal': !this.fromScreen,
          },
        }
      : {};
  },
};



// WEBPACK FOOTER //
// ./src/pages/default/popup/forms/component.js